import React, { Component } from "react";
import { View, ScrollView, StyleSheet } from "react-native";
import Text from "../../components_v2/TextFont";
import ArTheme from "../../argon-ui/Theme";

import { translate } from "../../locales/translate";

import { ScenarioIconProvider } from "../../viewModels/Scenario";
import { IconButton } from "../../components_v2/Buttons";
import { FONT_FAMILIES } from "../../../assets/consts/faCharCodes";

/**@augments {Component<props, state>}*/
class VirtualCondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iconName: this.props.initIcon || "",
    };

    this.iconsList = new ScenarioIconProvider().getAllV6();
  }
  handleOnIconSelect = (icon) => {
    this.setState({ iconName: icon }, () => {
      this.props.onIconSelect && this.props.onIconSelect(icon);
    });
  };
  render() {
    return (
      <View>
        <Text>{translate("scenario.pickAnIcon")}</Text>
        <ScrollView horizontal={true} style={{ flexDirection: "row" }}>
          {this.iconsList.map((icon, idx) => {
            return (
              <IconButton
                key={idx}
                onPress={() => this.handleOnIconSelect(icon)}
                style={{
                  borderWidth: 1,
                  borderColor: ArTheme.COLORS.BORDER,
                  width: 42,
                  height: 42,
                  borderRadius: 5,
                  margin: 3,
                  backgroundColor: "#FFF",
                  justifyContent: "center",
                }}
                icon={{
                  code: icon,
                  style: {
                    color:
                      this.state.iconName == icon
                        ? ArTheme.COLORS.ACTIVE
                        : ArTheme.COLORS.MUTED,
                    fontFamily:
                      this.state.iconName == icon
                        ? FONT_FAMILIES.PRO_REGULAR
                        : FONT_FAMILIES.PRO_LIGHT,
                    fontSize: 27,
                  },
                }}
              />
            );

            {
              /* return (
              <TouchableHighlight
                key={idx}
                style={styles.iconButton}
                underlayColor={ArTheme.COLORS.ACTIVE}
                onPress={() => this.handleOnIconSelect(icon)}
              >
                <View>
                  <FontAwesomeIcon
                    icon={icon}
                    size={45}
                    style={{ alignSelf: "center" }}
                    color={
                      this.state.iconName == icon.iconName
                        ? ArTheme.COLORS.ACTIVE
                        : ArTheme.COLORS.BORDER
                    }
                  />
                </View>
              </TouchableHighlight>
            ); */
            }
          })}
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  iconButton: {
    height: 50,
    width: 50,
    borderRadius: 5,
    borderColor: ArTheme.COLORS.BORDER,
    backgroundColor: ArTheme.COLORS.WHITE,
    borderWidth: 1,
    padding: 10,
    marginHorizontal: 10,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default VirtualCondition;
